<app-loader [loading]="loading()">
  <router-outlet></router-outlet>
  <div id="ot-sdk-cookie-policy"></div>
</app-loader>
